import { safeMain } from "./inference/entry";

safeMain();
